import React, {FC} from 'react';
import {PageContent, TagType} from "../Post-List/core/_model";
import {KTSVG} from "../../../../_metronic/helpers";
import './content.css'
type prop = {
    data : PageContent,
    index : number,
    removeRow : (e:number)=>void,
    addGrid : (e:number)=>void,
    rowUp:(e:number)=>void,
    rowDown :(e:number)=>void,
    addContToChild : (index : number , ChildIndex : number) =>void
    editContToChild : (index : number , ChildIndex : number | undefined) =>void,
    onEditElement : (index : number , ChildIndex : number | undefined) =>void,


}
const ContentChild :FC<prop>= ({data,index,removeRow,addGrid,rowUp,rowDown,addContToChild,editContToChild,onEditElement}) => {
    return (
        <div className="rowChild">

            {data.tagType === TagType.Row && (
                <div>
                    <div className="row">

                    </div>



                    <div className="text-center mb-1">
                        <button type="button" onClick={()=>addGrid(index)} className="btn btn-icon btn-active-icon-warning btn-active-text-warning"><i className="las la-plus fs-2 me-2"/></button>

                    </div>
                    <div className="hiden text-end">

                        <button type="button" onClick={()=>{rowDown(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-down"></i></button>
                        <button type="button" onClick={()=>{rowUp(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-up"></i></button>
                        <button type="button" onClick={()=>{removeRow(index)}} className="btn btn-sm btn-icon btn-light-danger"><i className="fa-solid fa-trash"></i></button>
                    </div>
                    <div  className="row border-dashed border-1 border-hover-warning p-3 rounded mb-3">
                        {data.child !== undefined && data.child?.length >0 && data.child?.map((child,chindex)=>{
                            switch (child.tagType){
                                case TagType.Col_1 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-1 text-center ">

                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{

                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (

                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-sm btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>

                                    )
                                }
                                case TagType.Col_2 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-2 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_3 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-3 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_4 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-4 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_5 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-5 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_6 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-6 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_7 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-7 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_8 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-8 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_9 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-9 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_10 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-10 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_11 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-11 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                                case TagType.Col_12 : {
                                    return (
                                        <div key={`child-${chindex}`} className="col-md-12 text-center border-dotted border-1 border-gray-700 p-3 rounded">
                                            {child.child !== undefined && child.child?.length > 0 && child.child.map((childFinal,indexChildChild)=>{
                                                switch (childFinal.tagType){
                                                    case TagType.HtmlContent : {
                                                        return (
                                                            <h3 onClick={()=>{editContToChild(index,chindex)}} key={`childFinal-${indexChildChild}`} className="cursor-pointer TagTitle">محتوا Html</h3>
                                                        )
                                                    }
                                                    case TagType.Section : {
                                                        return (
                                                            <h3 onClick={()=>onEditElement(index,chindex)} key={`childFinalH-${indexChildChild}`} className="cursor-pointer TagTitle">{childFinal.sectionTitle}</h3>
                                                        )
                                                    }
                                                }
                                            })}
                                            {child.child === undefined  && (
                                                <button type="button" onClick={()=>addContToChild(index,chindex)} className="btn btn-light-twitter btn-outline btn-outline-dashed btn-outline-info btn-active-light-info btnAdd"> <i className="las la-plus fs-2 me-2"/>افزودن</button>
                                            )}
                                        </div>
                                    )
                                }
                            }

                        })}

                    </div>
                </div>
            )}
            {data.tagType === TagType.HtmlContent && (
                <>
                    <div className="hiden text-end">
                        <button type="button" onClick={()=>{rowDown(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-down"></i></button>
                        <button type="button" onClick={()=>{rowUp(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-up"></i></button>
                        <button type="button" onClick={()=>{removeRow(index)}} className="btn btn-sm btn-icon btn-light-danger"><i className="fa-solid fa-trash"></i></button>
                    </div>
                    <h3 onClick={()=>{editContToChild(index,undefined)}} className="TagTitle">محتوا Html</h3>
                </>

            )}
            {data.tagType === TagType.Section && (
                <>
                    <div className="hiden text-end">
                        <button type="button" onClick={()=>{rowDown(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-down"></i></button>
                        <button type="button" onClick={()=>{rowUp(index)}} className="btn btn-sm btn-icon btn-light-linkedin"><i className="fa-solid fa-arrow-up"></i></button>
                        <button type="button" onClick={()=>{removeRow(index)}} className="btn btn-sm btn-icon btn-light-danger"><i className="fa-solid fa-trash"></i></button>
                    </div>
                    <h3 onClick={()=>onEditElement(index,undefined)} className="cursor-pointer TagTitle">{data.sectionTitle}</h3>
                </>
            )}
        </div>
    )



};

export default ContentChild;